import React, { Component } from "react";
import {
  Container,
  Paper,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell
} from "@material-ui/core";
//homeicon
import HomeIcon from "@material-ui/icons/Home";
//objeto firebase
import { consumerFirebase } from "../../server";
//pop pup de mensaje
import { openMessageError } from "../../session/actions/openMessageAction";
//componente para añadir imagenes
import ImageUploader from "react-images-upload";
//genera una clave unica para cada imagen
import { v4 as uuidv4 } from "uuid";
//funcionalidad del buscador
import { createKeyword } from "../../session/actions/Keyword";

//estilos del componente
const style = {
  container: {
    paddingTop: "8px"
  },
  paper: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#f5f5f5"
  },
  link: {
    display: "flex"
  },
  homeIcon: {
    width: 20,
    heigth: 20,
    marginRight: "4px"
  },
  submit: {
    marginTop: 15,
    marginBotton: 10
  },
  image: {
    heigth: "150px",
    width: "300px"
  }
};

class NewEstate extends Component {
  //estado del componente
  state = {
    estate: {
      direction: "",
      city: "",
      country: "",
      description: "",
      inside: ""
    },
    archives: []
  };
  //capturar texto de los inputs text
  addingDate = e => {
    let estate_ = Object.assign({}, this.state.estate);
    estate_[e.target.name] = e.target.value;
    this.setState({
      estate: estate_
    });
  };

  //funcion para subir imagenes
  //al array de documentos se le crea una propiedad urlTemp, se llama al metodo de javascript createObjectURL para poder crear una url temporal para poder mostrar la foto temporal dentro de la pagina sin necesidad de guardarlo en firebase
  //las fotos se guardan en firebase una vez el usuario presiona el boton de guardar
  uploadImage = images => {
    Object.keys(images).forEach(function(key) {
      images[key].urlTemp = URL.createObjectURL(images[key]);
    });
    this.setState({
      archives: this.state.archives.concat(images)
    });
  };

  //guardar en la base de datos el nuevo inmueble
  saveEstate = () => {
    //codigo para guardar imagenes en ddbb
    const { estate, archives } = this.state;
    //crea a cada imagen(archivo) un alias que servira para posteriormente llamar al archivo
    //el alias, como identificador unico de la imagen, se almacenara en la bbdd (firestore/firebase)
    Object.keys(archives).forEach(function(key) {
      let value_id = Math.floor(new Date().getTime() / 1000);
      let value_name = archives[key].name;
      let value_extension = value_name.split(".").pop();
      archives[key].alias = (
        value_name.split(".")[0] +
        "_" +
        value_id +
        "." +
        value_extension
      )
        .replace(/\s/g, "_")
        .toLowerCase();
    });

    //determina en que campos va a buscar para mostrar los resultados de la busqueda
    //llamamos a la funcion createKeyword() del archivo Keyword.js
    const searchTextKeyword =
      estate.direction + " " + estate.city + " " + estate.country;
    let keywords = createKeyword(searchTextKeyword);

    //funcion para guardar documentos en bbdd - funcion saveDocuments en server/firebase
    this.props.firebase.saveDocuments(archives).then(list_urls => {
      //creamos dos nuevos campos en bbdd para almacenar nuevos valores
      estate.photos = list_urls;
      estate.keywords = keywords;

      //codigo añadido despues del login por telefono
      //agrega la logica para añadir campo a la coleccion de estates el id de usuario, a fin de que en su sesion se vean los estates registrados por él
      //creamos nuevo campo owner
      estate.owner = this.props.firebase.auth.currentUser.uid;
      
      //codigo para guardar datos de inputs de tipo texto en bbdd
      //llamada al objeto firebase
      this.props.firebase.db
        .collection("Estates")
        .add(estate)
        .then(success => {
          this.props.history.push("/");
        })
        .catch(error => {
          openMessageError({
            open: true,
            message: error
          });
        });
    });
  };

  //funcion para eliminar las imagenes del state de archives[]
  deleteImage = image_name => () => {
    this.setState({
      archives: this.state.archives.filter(archive => {
        return archive.name !== image_name;
      })
    });
  };

  render() {
    //id de la imagen en ImageUploader - key
    let imageKey = uuidv4();

    return (
      <Container style={style.container}>
        <Paper style={style.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Breadcrumbs aria-label="breadcrump">
                <Link color="inherit" style={style.link} href="/">
                  <HomeIcon style={style.homeIcon} />
                  Home
                </Link>
                <Typography color="textPrimary">New estate</Typography>
              </Breadcrumbs>
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                name="direction"
                label="Estate direction"
                fullWidth
                value={this.state.estate.direction}
                onChange={this.addingDate}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="city"
                label="City"
                fullWidth
                value={this.state.estate.city}
                onChange={this.addingDate}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="country"
                label="Country"
                fullWidth
                value={this.state.estate.country}
                onChange={this.addingDate}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                name="description"
                label="Estate description"
                fullWidth
                multiline
                value={this.state.estate.description}
                onChange={this.addingDate}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                name="inside"
                label="Estate inside"
                fullWidth
                multiline
                value={this.state.estate.inside}
                onChange={this.addingDate}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={6}>
              <ImageUploader
                key={imageKey}
                withIcon={true}
                buttonText="Select images"
                onChange={this.uploadImage}
                imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
                maxFileSize={5242880} //5 MB
              />
            </Grid>
            {/* tabla con imagenes que imprime imagenes contenidas en el state archives[] */}
            <Grid item xs={12} sm={6}>
              <Table>
                <TableBody>
                  {this.state.archives.map((element, i) => (
                    <TableRow key={i}>
                      <TableCell align="center">
                        <img
                          src={element.urlTemp}
                          style={style.image}
                          alt={element.name}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          onClick={this.deleteImage(element.name)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
          </Grid>

          <Grid container justify="center">
            <Grid item xs={12} md={6}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                style={style.submit}
                onClick={this.saveEstate}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }
}

export default consumerFirebase(NewEstate);
